import { Link } from "react-router-dom";
import { MapPin, TrendingUp } from "lucide-react";
import { money, pct } from "@/lib/api";
import { useDisplayCurrency } from "@/context/CurrencyContext";

export function PropertyCard({ p }) {
  const funded = p.funded_percent || 0;
  const { currency: displayCur, convert } = useDisplayCurrency();
  const native = (p.currency || "INR").toUpperCase();
  const isConverted = native !== displayCur;
  return (
    <Link to={`/property/${p.id}`} data-testid={`property-card-${p.id}`}
      className="group block bg-white border border-[#E5DFD5] rounded-2xl overflow-hidden hover-lift">
      <div className="relative aspect-[4/3] overflow-hidden bg-[#F3EFEA]">
        <img src={p.hero_image} alt={p.title} loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        <div className="absolute top-3 left-3 flex gap-2">
          <span className="px-2.5 py-1 rounded-full text-[10px] font-semibold tracking-widest uppercase bg-[#0B192C] text-[#C5A059]">
            {p.property_type}
          </span>
          <span className="px-2.5 py-1 rounded-full text-[10px] font-semibold tracking-widest uppercase bg-[#C5A059] text-[#0B192C]">
            {p.occupancy_status}
          </span>
        </div>
      </div>
      <div className="p-5 space-y-3">
        <div>
          <h3 className="text-lg font-serif font-medium leading-snug text-[#0B192C]">{p.title}</h3>
          <div className="text-sm text-slate-500 flex items-center gap-1 mt-1">
            <MapPin className="h-3.5 w-3.5" />{p.location}
          </div>
        </div>
        <div className="flex justify-between items-baseline">
          <div>
            <div className="overline">Assured Yield</div>
            <div className="font-mono text-lg text-[#0F5132] font-semibold">{pct(p.assured_rental_yield, 1)}</div>
          </div>
          <div className="text-right">
            <div className="overline">Min. Ticket</div>
            <div className="font-mono text-lg text-[#0B192C] font-semibold">{money(convert(p.price_per_unit, native), displayCur)}</div>
            {isConverted && <div className="text-[10px] font-mono text-slate-400 mt-0.5">≈ {money(p.price_per_unit, native)}</div>}
          </div>
        </div>
        <div>
          <div className="flex justify-between text-xs text-slate-500 mb-1.5">
            <span className="font-mono">{funded.toFixed(1)}% funded</span>
            <span>{money(convert(p.total_value, native), displayCur)}</span>
          </div>
          <div className="h-1.5 bg-[#F3EFEA] rounded-full overflow-hidden">
            <div className="h-full bg-[#C5A059] transition-all" style={{ width: `${funded}%` }} />
          </div>
        </div>
      </div>
    </Link>
  );
}
